export const ADD_PROJECT_REQUEST = " ADD_PROJECT_REQUEST";
export const ADD_PROJECT_SUCCESS = " ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAILURE = " ADD_PROJECT_FAILURE";
